import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { RANGE } from "@/constants/testIds";

export const CompareView = ({ spas, onClose }) => {
  const labels = [];
  spas.forEach((s) => (s.specs || []).forEach((sp) => { if (!labels.includes(sp.label)) labels.push(sp.label); }));
  const val = (s, label) => (s.specs || []).find((x) => x.label === label)?.value || "—";

  return (
    <AnimatePresence>
      <motion.div className="fixed inset-0 z-[70] flex items-center justify-center p-4"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
        <motion.div
          className="relative w-full max-w-5xl overflow-hidden rounded-2xl border border-white/10 bg-[#1d1f26]/95 backdrop-blur-xl"
          initial={{ y: 24, opacity: 0, scale: 0.98 }} animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 24, opacity: 0 }} transition={{ type: "spring", stiffness: 260, damping: 24 }}
          data-testid={RANGE.compareModal}
        >
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
            <h3 className="font-display text-xl font-semibold tracking-tight">Compare models</h3>
            <button onClick={onClose} className="text-slate-400 hover:text-white" data-testid={RANGE.compareClose}><X size={20} /></button>
          </div>

          <div className="max-h-[75vh] overflow-auto">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr>
                  <th className="sticky left-0 top-0 z-10 bg-[#1d1f26] p-3" />
                  {spas.map((s) => (
                    <th key={s.id} className="min-w-[180px] border-b border-white/10 p-3 text-center align-top">
                      <div className="mx-auto mb-2 h-24 w-24 overflow-hidden rounded-lg bg-white/5">
                        {s.image_url ? <img src={mediaUrl(s.image_url)} alt={s.name} className="h-full w-full object-contain p-1.5" /> : null}
                      </div>
                      {s.brand ? <div className="text-[10px] uppercase tracking-wide text-amber-400">{s.brand}</div> : null}
                      <div className="font-display text-sm font-semibold leading-tight text-white">{s.name}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {labels.map((label, i) => (
                  <tr key={label} className={i % 2 ? "bg-white/[0.02]" : ""}>
                    <td className="sticky left-0 z-10 whitespace-nowrap bg-[#1d1f26] p-3 text-[11px] font-semibold uppercase tracking-wide text-slate-500">{label}</td>
                    {spas.map((s) => (
                      <td key={s.id} className="border-t border-white/5 p-3 text-center text-slate-200">{val(s, label)}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
